export enum ShareTabs {
  'secure',
  'privateLink',
}
interface ShareTabProps {
  [key: string]: {
    title: string;
    description: string;
  };
}
export const shareTabs: ShareTabProps = {
  [ShareTabs.secure]: {
    title: 'secure-title',
    description: 'secure-description',
  },
  [ShareTabs.privateLink]: {
    title: 'private-link',
    description: 'private-link-description',
  },
};
